import request from '../utils/request';

export function getKnowledgeBase() {
    return request({
        url:'/api/knowledge-base/get-knowledge-base/',
        method:'get'
    })
}
export function storeKnowledgeBase(data){
    return request({
        url:'/api/knowledge-base/get-knowledge-base/',
        method:'post',
        data
    })
}
export function deleteKnowledgeBase(data) {
    return request({
        url:`/api/knowledge-base/${data.kb_id}/knowledge-base-delete/`,
        method:'delete',
    })
}

export function updateKnowledgeBase(data) {
    return request({
        url:`/api/knowledge-base/knowledge-base-update/`,
        method:'put',
        data
    })
}

export function getKbById(data) {
    return request({
        url:`/api/knowledge-base/get-detail-knowledge-base/${data.id}`,
        method:'get'
    })
}

export function storeNewKbItem(data){
    return request({
        url:'/api/knowledge-base/store-knowledge-base-item/',
        method:'post',
        data
    })
}

export function getKbItemDetail(data) {
    return request({
        url:'/api/knowledge-base/get-kb-item-detail/',
        method:'get',
        params:data
    })
}